import React, { useContext } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { AuthContext } from "../context/authContext";

export default function PrivateRoutes() {
  const { isAuthorise } = useContext(AuthContext);
  return isAuthorise  ? <Outlet /> : <Navigate to="/" />;
}